import { ColumnDataType } from '../../../../types.js';

function isDateType(type) {
    return (type === ColumnDataType.Date ||
        type === ColumnDataType.Time ||
        type === ColumnDataType.Timestamp ||
        type === ColumnDataType.TimestampWithTimeZone ||
        new RegExp(ColumnDataType.TimestampWithTimeZoneP).test(type) ||
        type === ColumnDataType.TimeWithTimeZone);
}
function isNumericType(type) {
    return (type === ColumnDataType.Numeric ||
        type === ColumnDataType.Decimal ||
        type === ColumnDataType.Bigint);
}
function isTextType(type) {
    return (type === ColumnDataType.Varchar ||
        new RegExp(ColumnDataType.VarcharP).test(type));
}
function heatmapMinMax(numbers) {
    let { max, min } = { max: -Infinity, min: Infinity };
    numbers.forEach((num) => {
        if (num > max) {
            max = num;
        }
        if (num < min) {
            min = num;
        }
    });
    if (min === Infinity) {
        min = 0;
    }
    if (max === -Infinity) {
        max = 100;
    }
    return { min, max };
}
function getXAxisDataColumn(visibleDataColumns) {
    const isOldChart = visibleDataColumns.filter((item) => typeof item.axis !== "undefined")
        .length <= 0;
    return isOldChart
        ? visibleDataColumns[0]
        : visibleDataColumns.filter((item) => item.axis && item.axis === "x")[0];
}
function getSeriesDataColumns(visibleDataColumns) {
    const isOldChart = visibleDataColumns.filter((item) => typeof item.axis !== "undefined")
        .length <= 0;
    return isOldChart
        ? visibleDataColumns.slice(1)
        : visibleDataColumns.filter((item) => !item.axis || (item.axis !== "x" && item.axis !== "value"));
}
function getValueDataColumn(visibleDataColumns) {
    const valueAxisColumns = visibleDataColumns.filter(item => item.axis === "value");
    return valueAxisColumns.length > 0 ? valueAxisColumns[0] : null;
}
function getHighchartsChartType(type) {
    switch (type) {
        case "AreaChart":
            return "area";
        case "BarChart":
            return "bar";
        case "ColumnChart":
            return "column";
        case "LineChart":
            return "line";
        case "PieChart":
            return "pie";
        case "HeatmapChart":
            return "heatmap";
        case "CombinedCharts":
            return null;
    }
}

export { getHighchartsChartType, getSeriesDataColumns, getValueDataColumn, getXAxisDataColumn, heatmapMinMax, isDateType, isNumericType, isTextType };
//# sourceMappingURL=chartUtils.js.map
